import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { Col, Container, Modal, Row } from 'react-bootstrap'
import {
  cancelIdentityInfoModalDialog,
  closeIdentityInfoModalDialog,
  resetIdentityInfoModalDialog,
  saveChangesIdentityInfoModalDialog,
  validateIdentityInfoModalDialog,
} from '../../actions/identity_info_modal_dialog'
import IdentityInfoForm from './identity_info_form'
import { fetchUserTxById } from '../../actions'
import { filterIdDocumentType, filterPassportOrFrontDocumentOrBack } from '../../utils/filters'

class IdentityInfoModalDialog extends PureComponent {
  handleCloseModal() {
    const { fetchUserTxById, closeIdentityInfoModalDialog, identityData } = this.props
    fetchUserTxById(identityData.transaction)
    closeIdentityInfoModalDialog()
  }

  render() {
    const { isModalDialogOpen, cancelIdentityInfoModalDialog, isChangesSaved, identityData, currentPhase } = this.props
    const onHide = isChangesSaved ? () => this.handleCloseModal() : cancelIdentityInfoModalDialog
    const images = identityData.identity_documents
      .filter((document) => filterIdDocumentType(document))
      .filter((document) => filterPassportOrFrontDocumentOrBack(document))
    return (
      <Modal show={isModalDialogOpen} onHide={onHide} size={images.length ? 'lg' : null}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Identity</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {images.length ? (
            <Container style={{ width: '840px' }}>
              <Row>
                <Col xs={4} md={6}>
                  {images.map((document, i) => (
                    <img key={i} alt={document.document_type} src={document.document} width='400px' />
                  ))}
                </Col>
                <Col xs={8} md={6}>
                  <IdentityInfoForm identityData={identityData} currentPhase={currentPhase} />
                </Col>
              </Row>
            </Container>
          ) : (
            <IdentityInfoForm identityData={identityData} currentPhase={currentPhase} />
          )}
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  isChangesSaved: state.identityInfoModalDialog.isChangesSaved,
  isValidated: state.identityInfoModalDialog.isValidated,
  newData: state.identityInfoModalDialog.newData,
  isModalDialogOpen: state.identityInfoModalDialog.isModalDialogOpen,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeIdentityInfoModalDialog,
      cancelIdentityInfoModalDialog,
      saveChangesIdentityInfoModalDialog,
      validateIdentityInfoModalDialog,
      resetIdentityInfoModalDialog,
      fetchUserTxById,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IdentityInfoModalDialog))
